import { Component, Input, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { EventEmitter } from "@angular/core";
import { ReactiveFormsModule } from '@angular/forms';
import { FieldResource } from "../../core/modules/openapi";

@Component({
  selector: "action_button",
  imports: [ReactiveFormsModule],
  template: `
    <div class="demo-full-width margin-top" [formGroup]="group">
      <button type="button" mat-raised-button color="primary" [disabled]="!field.enabled"
              (click)="onClick($event)">{{ field.displayName }}
      </button>
    </div>
  `,
  standalone: true,
  styles: []
})
export class ActionButtonComponent implements OnInit {
  field: FieldResource;
  group: FormGroup;
  @Output() callFunction = new EventEmitter();

  ngOnInit() {}

  onClick(event:any) {
    if(this.field?.action) {
      this.callFunction.emit(this.field.action);
    }
  }
}
